import Swiper from "swiper";
import { $Q, $Qll } from '../utils/query-selector';
import 'swiper/css/bundle';

const initBestSellers = () => {
  let swipersbundleset = [];

  function initSwipersBundleSet() {
    const swiperElements = $Qll('.best-sellers__collections--mobile');

    swiperElements.forEach(function (element) {
      const swiper = new Swiper(element, {
        slidesPerView: 1.3,
        breakpoints: {
          320: {
            slidesPerView: 1.3
          },
          768: {
            slidesPerView: 2.3
          }
        },
        spaceBetween: 16,
        grid: {
          rows: 1,
        }
      });

      swipersbundleset.push(swiper);
    });
  }

  function destroySwipersBundleSet() {
    swipersbundleset.forEach(function (swiper) {
      swiper.destroy();
    });

    swipersbundleset = [];
  }

  if (window.innerWidth <= 992) {
    initSwipersBundleSet();
  } else {
    destroySwipersBundleSet();
  }

  window.addEventListener('resize', function () {
    if (window.innerWidth <= 992) {
      if (swipersbundleset.length === 0) {
        initSwipersBundleSet();
      }
    } else {
      destroySwipersBundleSet();
    }
  });
};

export default initBestSellers;
